<template>
    <div id="app" class="container">
        <div>
            <b-navbar toggleable="lg" type="light">
                <b-navbar-brand href="/ui">SMS Gateway</b-navbar-brand>
                    <b-navbar-nav>
                      <b-nav-item href="/ui/list">List all messages</b-nav-item>
                      <b-nav-item href="/ui/stats">Statistics</b-nav-item>
                      <b-nav-item href="/ui/send">Send</b-nav-item>
                      <b-nav-item href="/ui/logout">Logout</b-nav-item>
                    </b-navbar-nav>
            </b-navbar>
        </div>

        <hr class="mt-0 mb-4">

        <b-container fluid>
            <router-view/>
        </b-container>
    </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.nounderline {
  text-decoration: none !important
}
</style>



// WEBPACK FOOTER //
// src/App.vue